"use client";

import { TABLE } from "@/components/tool-kit/styles";

/** The alignment as monospaced text that scrolls sideways instead of wrapping. */
export function AlignmentText({
  text,
  label,
}: {
  text: string;
  label: string;
}) {
  return (
    <figure>
      <figcaption className="sr-only">{label}</figcaption>
      <pre className="overflow-x-auto rounded-lg border border-border bg-card p-4 font-mono text-foreground text-xs leading-relaxed sm:text-sm">
        {text}
      </pre>
    </figure>
  );
}

/** The dynamic-programming grid of a short alignment, with the traceback path shaded. */
export function ScoreMatrix({
  rowLabels,
  columnLabels,
  grid,
  path,
  caption,
  fmt,
}: {
  rowLabels: readonly string[];
  columnLabels: readonly string[];
  grid: readonly (readonly number[])[];
  path: ReadonlySet<string>;
  caption: string;
  fmt: (value: number, options?: Intl.NumberFormatOptions) => string;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <table className={`${TABLE} text-center font-mono`}>
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr>
            <th className="px-2 py-1" scope="col" />
            {columnLabels.map((label, j) => (
              <th
                className="px-2 py-1 text-muted-foreground"
                // biome-ignore lint/suspicious/noArrayIndexKey: residues repeat
                key={j}
                scope="col"
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {grid.map((row, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: matrix rows are positional
            <tr key={i}>
              <th className="px-2 py-1 text-muted-foreground" scope="row">
                {rowLabels[i]}
              </th>
              {row.map((value, j) => (
                <td
                  className={`px-2 py-1 ${path.has(`${i},${j}`) ? "bg-primary/15 font-semibold text-foreground" : "text-muted-foreground"}`}
                  // biome-ignore lint/suspicious/noArrayIndexKey: matrix cells are positional
                  key={j}
                >
                  {fmt(value)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
